import { ProgressItem as ProgressItemDto } from "src/app/proxy/progresses/models";

export class ProgressItem {
  localId: string;
  id: number;
  activityReportId: string;
  activityId: number;
  quantity: number;
  total: number;
  deleted: boolean;
  updated: string;
  version: number;
  operation: string;

  constructor(dto: ProgressItemDto | ProgressItem) {
    Object.assign(this, dto);

    this.localId = ('localId' in dto ? dto.localId : undefined) ?? crypto.randomUUID();
  }
}
